import Image from "next/image";
import IMAGES from "@/public/assets/img";

const ProfessionalsAdvantage = ({ professionData, advantageData }) => {
    
  return (
    <section className="my-[100px] sm:my-20">
      <div className="max-w-[1100px] md:mx-3 sm:mx-3 mx-auto">
        <div className="text-center mx-auto">
          <h2 className="text-heading5 sm:text-3xl font-medium text-baseBlack">
            {advantageData.title}
          </h2>
          <p className="text-baseBlack text-lg mt-xsp">
            {advantageData.description}
          </p>
        </div>

        <div className="mx-auto flex sm:flex-col gap-6 mt-6 items-center">
          <Image
            src={advantageData.bannerImage}
            alt="Advantage Banner"
            width={499}
            height={352}
            priority={true}
            className="rounded-lg mx-auto"
          />

          <div className="flex flex-col w-2/4 sm:w-full gap-6">
            {advantageData.features.map((feature) => (
              <div key={feature.id} className="flex-1 flex gap-3">
                <Image
                  src={feature.icon.src}
                  alt={feature.title}
                  width={feature.icon.width}
                  height={feature.icon.height}
                  quality={true}
                />
                <div>
                  <h3 className="font-medium text-baseBlack text-lg sm:text-base">
                    {feature.title}
                  </h3>
                  <p className="text-base text-[#1A1A1A] mt-xsp sm:text-sm">
                    {feature.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mx-auto mt-[100px] sm:mt-20">
          <h2 className="text-heading5 sm:text-3xl font-medium text-baseBlack text-center">
            {professionData.title}
          </h2>

          <div className="flex justify-center gap-4 mt-20 sm:flex-col">
            {professionData.professions.map((prof) => (
              <div
                key={prof.id}
                className={`${prof.bgColor} bordre border-[#F9F9FB] px-3 py-6 rounded-xl shadow-sm flex flex-col items-center relative w-[380px] sm:w-full ${
                    prof.id === 1 ? "sm:mb-16" : ''}`}
              >
                <div className="absolute -top-12">
                <Image
                  src={prof.image}
                  alt={prof.name}
                  width={120}
                  height={120}
                  priority={true}
                  className="rounded-full"
                  quality={100}
                />
                </div>
                <h3 className="mt-12 font-bold text-[22px] text-baseBlack">
                  {prof.name}
                </h3>
                <ul className="mt-4 text-left w-full space-y-4">
                  {prof.benefits.map((benefit, index) => {
                    const [title, desc] = benefit.split("–"); 
                    return (
                      <li key={index} className="flex gap-1 items-start">
                        <Image
                          src={IMAGES.ImportFactoring.yes}
                          alt="correct"
                          width={24}
                          height={20}
                        />
                        <div>
                          <span className="font-medium text-base2 text-baseBlack">{title.trim()}</span>
                          {desc && <p className="text-base text-[#1A1A1A] mt-xsp">{desc.trim()}</p>}
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfessionalsAdvantage;
